



































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto'
import LocationTypeCreate from '@/components/LocationTypes/LocationTypeCreate.vue';
import LocationTypeEdit from '@/components/LocationTypes/LocationTypeEdit.vue'; 
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'LocationTypes',
  components: { LocationTypeCreate, LocationTypeEdit }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentLocationType(null);
    }

    async updateLocationType(locationType: LocationTypeDto) {
        AgencySettingsModule.updateCurrentLocationType(locationType);
    }

    get currentLocationType() {
        return AgencySettingsModule.currentLocationType;
    }

    get loadingLocationTypes() {
        return AgencySettingsModule.loadingLocationTypes;
    }

    get locationTypes() {
        return AgencySettingsModule.locationTypes;
    }

    async deleteLocationType() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this ' + this.Labels.location + ' Type?', options);
        if (result) {
            AgencySettingsModule.deleteLocationType(this.currentLocationType);
        }
    }
}
